import { createContext, useContext } from 'react'

export const RegionContext = createContext({
  region: 'ZA',
})
export const RegionProvider = RegionContext.Provider
export const RegionConsumer = RegionContext.Consumer
export const useRegion = () => {
  return useContext(RegionContext)
}
